import React from "react";
import { withRouter } from "react-router-dom";

import Api from "../../../../lib/componentApi";

import getLocalData from "../../../../lib/getLocalData";

import AddItem from "../../../../components/Restaurants/Products/AddItem";
import UpdateItem from "../../../../components/Restaurants/Products/UpdateItem";

class Submit extends React.Component {
  constructor(props, context) {
    super(props, context);
    const { basketData, allAddresses, itemId } = props;
    const matchedItem =
      itemId &&
      basketData &&
      basketData.items &&
      basketData.items.find(
        basketItem =>
          basketItem.restaurantItemId === itemId ||
          basketItem.item_id === itemId
      );
    const addressData = getLocalData("deliveryDetails") || {};
    this.state = {
      item: null,
      userAddress: addressData,
      restaurantId: props.restaurantId,
      restaurantName: props.restaurantName,
      allAddresses,
      restaurantItemId: props.restaurantItemId || "",
      itemId,
      loading: true,
      matchedItem
    };
    this.getItem();
  }
  componentDidMount() {
    this.getItem();
  }
  getItem = () => {
    const { itemId, restaurantId, onCloseItem } = this.props;
    Api.post(
      "/api/product/item",
      { restaurantItemId: itemId, restaurantUid: restaurantId },
      (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
            onCloseItem();
          }
        } else if (response.code) {
          onCloseItem();
          console.log(response, "code-item");
        } else {
          this.setState({ item: response });
        }
        this.setState({ loading: false });
      }
    );
  };
  closeItem = (e, basketData) => {
    const { onCloseItem } = this.props;
    if (basketData) {
      this.setState({ basketData }, () => {
        onCloseItem(e, basketData);
      });
    } else {
      onCloseItem(e);
    }
  };
  render() {
    const {
      onSubmitItem,
      onClickBack,
      userId,
      deliveryFee,
      status,
      restaurantAddress,
      slugName,
      isFreebie
    } = this.props;
    const { slugAdminWard, city } = restaurantAddress || "";
    const {
      item,
      userAddress,
      restaurantId,
      loading,
      restaurantName,
      allAddresses,
      matchedItem
    } = this.state;

    const { basketData } = this.props;
    return (
      item &&
      ((status === "update" && (
        <UpdateItem
          item={item}
          basketData={basketData}
          selectedItem={matchedItem}
          onCloseItem={this.closeItem}
          onSubmitItem={onSubmitItem}
          onClickBack={onClickBack}
          userId={userId}
          loading={loading}
          isFreebie={isFreebie}
        />
      )) || (
        <AddItem
          item={item}
          userAddress={userAddress}
          restaurantId={restaurantId}
          restaurantName={restaurantName}
          basketData={basketData}
          onCloseItem={this.closeItem}
          userId={userId}
          allAddresses={allAddresses}
          deliveryFee={deliveryFee}
          loading={loading}
          slugAdminWard={slugAdminWard}
          city={(city && city.slugName) || ""}
          slugName={slugName}
        />
      ))
    );
  }
}

export default withRouter(Submit);
